<template>
  <el-dialog :title="title" :visible.sync="visible" :close-on-click-modal="false" width="640px" @close="cancleBtn">
    <el-form :model="employeeForm" :rules="rules" ref="empForm" label-width="120px" class="demo-ruleForm" v-if="isEdit">
      <el-form-item label="员工姓名：" prop="userName">
        <el-input v-model="employeeForm.userName"></el-input>
      </el-form-item>
      <el-form-item label="员工账号：" prop="userCode">
        <el-input v-model="employeeForm.userCode" :disabled="vstatus"></el-input>
      </el-form-item>
      <el-form-item label="其他联系方式：" prop="contact">
        <el-input v-model="employeeForm.contact" maxlength="50" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="状态：" prop="status" v-if="vstatus">
        <el-radio-group v-model="employeeForm.status">
          <el-radio :label="true">启用</el-radio>
          <el-radio :label="false">停用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="可查看权限：" prop="userRoles">
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">
          全选
        </el-checkbox>
        <el-checkbox-group v-model="employeeForm.userRoles" @change="handleCheckedCitiesChange">
          <el-checkbox :label="item.id" name="userRoles" v-for="(item, index) in userRoles" :key="index">
            {{ item.roleName }}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <label for="remark">
        <span style="vertical-align: top">备注：</span>
        <el-input
          id="remark"
          type="textarea"
          v-model="employeeForm.remark"
          :rows="6"
          resize="none"
          maxlength="225"
          show-word-limit
        ></el-input>
      </label>
      <p class="formTip">
        <i class="el-icon-warning"></i>
        <span>保存后对方手机将收到通知</span>
      </p>
      <el-form-item style="margin-top: 20px">
        <el-button class="dialogBtn" @click="cancleBtn" size="medium">取消</el-button>
        <el-button
          class="dialogBtn"
          type="primary"
          size="medium"
          @click="submitForm('empForm')"
          :icon="btnLoading ? 'el-icon-loading' : ''"
        >
          确认
        </el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { addEmployee, editEmployee, getRoles, getEmployeeDetail } from '../../../server/employee'
export default {
  name: 'emp-dialog',
  props: {
    title: String,
    vstatus: Boolean
  },
  data () {
    var validateLength = (rule, value, callback) => {
      if (value.trim().length > 50) {
        callback(new Error('输入长度最多输入50字符'))
      } else {
        callback()
      }
    }
    return {
      checkAll: false,
      btnLoading: false,
      isIndeterminate: false,
      isEdit: true,
      employeeForm: {
        userRoles: []
      },
      userRoles: [],
      rules: {
        userName: [
          { required: true, message: '请输入员工姓名', trigger: 'blur' },
          { validator: validateLength, trigger: 'change' }
        ],
        userCode: [
          { required: true, message: '请输入员工账号', trigger: 'blur' },
          { validator: validateLength, trigger: 'change' }
        ],
        status: [{ required: true, message: '请至少选择一项', trigger: 'change' }],
        userRoles: [{ type: 'array', required: true, message: '请至少选择一项', trigger: 'change' }]
      },
      visible: false
    }
  },
  created () {
    this.getRoles()
  },
  methods: {
    handleCheckAllChange (val) {
      if (val) {
        this.employeeForm.userRoles = this.userRoles.map(item => item.id)
      } else {
        this.employeeForm.userRoles = []
      }
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange (value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.userRoles.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.userRoles.length
    },
    async handleVisible (userId) {
      if (userId) {
        const { data } = await getEmployeeDetail(userId)
        console.log(data)
        if (data.code === this.$code) {
          this.employeeForm = data.data
          let arr = []
          for (let i of data.data.userRoles) {
            arr.push(i.id)
          }
          this.employeeForm.userRoles = arr
          this.handleCheckedCitiesChange(this.employeeForm.userRoles)
        }
      } else {
        this.$nextTick(() => {
          this.employeeForm = {
            userRoles: []
          }
          this.$refs['empForm'].resetFields()
        })
      }
      this.visible = true
    },
    /**
     * 获取权限列表
     */
    async getRoles () {
      const { data } = await getRoles()
      if (data.code === this.$code) {
        this.userRoles = data.data
      }
    },
    /**
     * 提交表单
     * 1、添加员工操作 --> 验证员工账号，不存在或未启用则提示账号不存在
     * 2、验证通过后，执行表单操作
     */
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.vstatus) {
            this.editEmp()
          } else {
            this.addEmp()
          }
        } else {
          return false
        }
      })
    },
    /**
     * 添加员工
     */
    async addEmp () {
      this.btnLoading = true
      let arr = []
      for (let i = 0; i < this.employeeForm.userRoles.length; i++) {
        arr.push(parseInt(this.employeeForm.userRoles[i]))
      }
      let reqData = {
        status: 1,
        user_name: this.employeeForm.userName,
        user_code: this.employeeForm.userCode,
        contact: this.employeeForm.contact,
        remark: this.employeeForm.remark,
        allot_role_ids: arr
      }
      const { data } = await addEmployee(reqData)
      if (data.code === this.$code) {
        this.$message({
          type: 'success',
          message: window.$t('system::tip::add_success')
        })
        this.cancleBtn()
        this.$emit('getEmps')
      }
    },
    /**
     * 编辑员工
     */
    async editEmp () {
      let arr = []
      for (let i = 0; i < this.employeeForm.userRoles.length; i++) {
        arr.push(parseInt(this.employeeForm.userRoles[i]))
      }
      let reqData = {
        status: this.employeeForm.status ? 1 : 0,
        user_name: this.employeeForm.userName,
        user_code: this.employeeForm.userCode,
        contact: this.employeeForm.contact,
        remark: this.employeeForm.remark,
        allot_role_ids: arr,
        userId: this.employeeForm.userId
      }
      const { data } = await editEmployee(reqData)
      if (data.code === this.$code) {
        this.visible = false
        this.$message({
          type: 'success',
          message: window.$t('system::tip::edit_success')
        })
        this.cancleBtn()
        this.$emit('getEmps')
      }
    },
    cancleBtn () {
      this.visible = false
      this.isIndeterminate = false
      this.checkAll = false
      this.btnLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
